export default "__VITE_ASSET__DcMt7clL__"